<template>
    <div id="index">
        <el-container>
            <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
                <el-main>
                    <nav-bar></nav-bar>
                    <el-form ref="CustomerInputDto" :model="CustomerInputDto" class="queryform_div" label-width="150px">
                        <el-row :gutter="24">
                            <el-col :md="6" :xs="24" :sm="24">
                                <el-form-item :label="$t('desc.customerName')">
                                    <el-input type="text" style="width: 100%" v-model="CustomerInputDto.customerName"
                                        size="small"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :md="6" :xs="24" :sm="24">
                                <el-form-item label="排序字段">
                                    <el-select v-model="CustomerInputDto.orderType" style="width: 100%" size="small"
                                        @change="changeOrderType">
                                        <el-option label="默认" value=""></el-option>
                                        <el-option label="运行时间" value="runningTime"></el-option>
                                        <el-option label="加载率" value="loadRate"></el-option>
                                        <el-option label="加卸载切换次数" value="loadChangeCount"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :md="6" :xs="24" :sm="24">
                                <el-form-item label="排序方向">
                                    <el-radio-group style="margin-top:10px;margin-left:10px;"
                                        v-model="CustomerInputDto.orderDirection">
                                        <el-radio label="0">升序</el-radio>
                                        <el-radio label="1">降序</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                                <el-button type="primary" @click="getDataList('search')" size="small">{{
                                    $t("button.query") }}</el-button>
                                <el-button @click="resetKeyword" size="small">{{
                                    $t("button.reset")
                                    }}</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                    <template>
                        <!-- <el-button
                type="default"
                @click="exportCustomerList()"
                :loading="loading"
                v-if="hasExportAuth"
                style="margin-bottom: 10px"
                >{{ $t("button.exportCustomerList") }}</el-button
              > -->
                        <div class="tableDiv">
                            <el-table :data="tableData1" stripe style="width: 100%" :empty-text="$t('desc.noData')">
                                <el-table-column type="index" :label="$t('title.serialNumber')" width="60" fixed="left">
                                </el-table-column>
                                <el-table-column prop="customerName" :label="$t('desc.customerName')" min-width="230px"
                                    fixed="left">
                                </el-table-column>
                                <el-table-column prop="customerCode" :label="$t('title.customerCode')"
                                    min-width="100px">
                                </el-table-column>
                                <el-table-column prop="brandCode" :label="$t('title.brand')" min-width="80px">
                                </el-table-column>
                                <el-table-column prop="customerCenter" :label="$t('title.customerCenter')"
                                    min-width="150px">
                                </el-table-column>
                                <el-table-column prop="companyType" :label="$t('title.companyType')" min-width="80px">
                                </el-table-column>
                                <el-table-column prop="compressorSumCount" label="空压机总台数" min-width="120px">
                                </el-table-column>
                                <el-table-column prop="compressorFSCount" label="定频空压机台数" min-width="120px">
                                </el-table-column>
                                <el-table-column prop="compressorVSDCount" label="变频空压机台数" min-width="120px">
                                </el-table-column>
                                <el-table-column prop="runningHourMonthFS" label="近一个月定频运行小时总数" min-width="120px">
                                </el-table-column>
                                <el-table-column prop="runningHourMonthVSD" label="近一个月变频运行小时总数" min-width="120px">
                                </el-table-column>
                                <el-table-column prop="loadUnloadChangeCountMonth" label="近一个月加卸载切换次数" min-width="120px">
                                </el-table-column>
                                <el-table-column prop="avgLoadRate" label="近一个月平均加载率" min-width="100px">
                                </el-table-column>
                                <el-table-column prop="provinceName" :label="$t('title.province')" min-width="80px">
                                </el-table-column>
                                <el-table-column prop="cityName" :label="$t('title.city')" min-width="80px">
                                </el-table-column>
                                <el-table-column prop="industryName" :label="$t('title.industry')" min-width="100px">
                                </el-table-column>
                                <el-table-column :label="$t('title.operate')" min-width="110px" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="primary" icon="el-icon-s-grid" title="查看设备列表" circle
                                            size="mini" @click="openClient(true, scope.row)"></el-button>
                                        <el-button type="primary" icon="el-icon-data-line" title="查看利用率及加载率趋势" circle
                                            size="mini" @click="openUseLoadRatePopup(true, scope.row)"></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination background :page-size="pagination.pageSize" :page-sizes="[10, 20, 50]"
                                :current-page.sync="pagination.current" @current-change="handleCurrentChange"
                                @size-change="handleSizeChange" layout="prev, pager, next,sizes"
                                :total="pagination.totalPage" style="text-align: center; margin-top: 10px">
                            </el-pagination>
                        </div>
                    </template>
                </el-main>
            </el-scrollbar>
        </el-container>


        <monitor-device-dialog :dialogClient="dialogClient" :title="dialogTitle" :deviceTable="deviceTableShow"
            :customerId="customerId" :activeLang="activeLang" @onSearchBtn="getDeviceTable"
            @openDevice="openMonitorListDevice" @dialogVisibleEvent="openClient" @changeCState="changeCState">
        </monitor-device-dialog>

        <!-- <monitor-dialog ref="monitorRef" :dialogClient="dialogMonitor" :title="dialogTitle"
            :gatherOption="gatherOptionShow" :monitorDataList="monitorDataList" :customer="hisCustomer"
            :activeLang="activeLang" :projectType="projectType" @onSearchBtn="getDeviceTable"
            @dialogVisibleEvent="openMonitor" @showEcharts="getMonitorHistory">
        </monitor-dialog> -->

        <monitor-deviceInfo-Dialog ref="deviceInfoRef" :dialogClient="dialogDevice" :title="deviceTitle"
            :DeviceInfo="DeviceInfo" :CustomerInfo="CustomerInfo" :gatherOption="ccnGatherOption"
            :ccnCodeList222="ccnCodeList222" :activeLang="activeLang" :isDingOrBian="isDingOrBian" :echartID="echartID"
            :echartIDHistory="echartIDHistory" :maintainList="maintainList" :IsShowSensitive="IsShowSensitive"
            :UseRateData="UseRateData" @getMonitorHistoryByGsn="getMonitorHistoryByGsn"
            @dialogVisibleEvent="openMonitorListDevice" @openCcnTable="openCcnTable" @getRealData="getRealData"
            @changeCode="changeCode" @openMaintain="openMaintainDialog" @openTripWarning="openTripWarningDialog">
        </monitor-deviceInfo-Dialog>

        <monitor-ccn-table :dialogClient="dialogDeviceCCN" :title="tableTitle" :tableCCN="tableCCN"
            :tableType="tableType" @dialogVisibleEvent="openCcnTable">
        </monitor-ccn-table>
        <monitor-TripWarning-Dialog :dialogClient="dialogTripWarning" title="告警监控"
            @dialogVisibleEvent="openTripWarningDialog">
        </monitor-TripWarning-Dialog>

        <el-dialog title="设备列表" :visible.sync="deviceListDialog" width="90%" top="5%">
            <el-form label-width="80px" style="height: 100%">
                <el-row :gutter="24"></el-row>
                <template>
                    <div class="DBDiv">
                        <div class="tableDiv">
                            <el-table :data="deviceTableData" stripe style="width: 100%"
                                :empty-text="$t('desc.noData')">
                                <el-table-column type="index" :label="$t('title.serialNumber')" width="60" fixed="left">
                                </el-table-column>
                                <el-table-column prop="dsn" :label="$t('desc.airCompressorSN')" width="140"
                                    fixed="left">
                                </el-table-column>

                                <el-table-column prop="brandName" :label="$t('title.brand')" min-width="80">
                                </el-table-column>
                                <el-table-column prop="modelId" :label="$t('title.airCompressorType')" width="270">
                                </el-table-column>

                                <el-table-column prop="customerName" :label="$t('desc.customer')" width="310">
                                    <template slot-scope="scope">
                                        {{ containTranslate(scope.row.customerName) }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="compressorNumber" :label="$t('desc.compressorNumber')"
                                    width="100">
                                </el-table-column>
                                <!-- <el-table-column
                  prop="customerCode"
                  label="客户代码"
                  width="100"
                >
                </el-table-column> -->

                                <el-table-column prop="serviceType" :label="$t('title.airCompressorService')"
                                    width="150">
                                </el-table-column>
                                <el-table-column prop="contractStatus" :label="$t('desc.contractStatus')" width="120">
                                    <template slot-scope="scope">
                                        {{ scope.row.contraStatus == 'Active' ?
                                            $t('desc.withinTheContractWarrantyPeriod')
                                            : $t('desc.outsideTheContractWarrantyPeriod') }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="contractStartDate" :label="$t('desc.contractStartDate')"
                                    width="160">
                                </el-table-column>
                                <el-table-column prop="contractEndDate" :label="$t('desc.contractEndDate')" width="160">
                                </el-table-column>
                                <el-table-column prop="ccn" :label="$t('title.controlsCCN')" width="200">
                                </el-table-column>
                                <el-table-column prop="ccnVersion" :label="$t('title.ccnVersion')" width="120">
                                </el-table-column>
                                <el-table-column prop="gsn" :label="$t('desc.gatewaySN')" width="150">
                                </el-table-column>
                                <!-- <el-table-column v-if="hasDeviceLocation" prop="locationAddress"
                                    :label="$t('desc.locationAddress')" width="150">
                                </el-table-column> -->
                                <el-table-column prop="lastUseRate" :label="$t('desc.UtilizationRate')" width="120">
                                </el-table-column>
                                <el-table-column prop="beatStatusName" :label="$t('title.gatewaystatus')" width="200">
                                    <template slot-scope="scope">
                                        {{ $t("gatewayState." + scope.row.beatStatusName) }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="gatewayState" :label="$t('title.isBinding')" width="200">
                                </el-table-column>
                                <el-table-column prop="registerTime" :label="$t('title.registerTime')" width="200">
                                </el-table-column>
                                <el-table-column prop="lastBeatTime" :label="$t('title.lastBeatTime')" width="200">
                                </el-table-column>
                                <el-table-column prop="installMethod" :label="$t('acronym.installMethod')" width="150">
                                    <template slot-scope="scope">
                                        <label>
                                            {{ $t("acronym." + scope.row.installMethod) }}
                                        </label>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="responsibleServiceSalesName"
                                    :label="$t('desc.responsibleServiceSalesName')" width="120">
                                </el-table-column>
                                <el-table-column prop="responsibleServiceSalesMobile"
                                    :label="$t('desc.responsibleServiceSalesMobile')" width="140">
                                </el-table-column>
                                <el-table-column prop="responsibleEngineerName"
                                    :label="$t('desc.responsibleEngineerName')" width="120">
                                </el-table-column>
                                <el-table-column prop="responsibleEngineerMobile"
                                    :label="$t('desc.responsibleEngineerMobile')" width="140">
                                </el-table-column>
                                <el-table-column prop="installDate" :label="$t('desc.installDate')" width="140">
                                </el-table-column>
                                <el-table-column prop="lastOverhaulInstallDate"
                                    :label="$t('desc.lastOverhaulInstallDate')" width="140">
                                </el-table-column>
                                <el-table-column prop="uploadTime" :label="$t('desc.lastOnlineTime')" width="140">
                                </el-table-column>
                                <el-table-column prop="isConnectedAsset" :label="$t('desc.isConnectedAsset')"
                                    width="140">
                                    <template slot-scope="scope">
                                        <label>
                                            {{ scope.row.isConnectedAsset ? $t("desc.是") : $t("desc.否") }}
                                        </label>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="digitalAssetStatus" :label="$t('desc.isRegisteredAsset')"
                                    width="140">
                                    <template slot-scope="scope">
                                        <label>
                                            {{ scope.row.digitalAssetStatus ? $t("desc.是") : $t("desc.否") }}
                                        </label>
                                    </template>
                                </el-table-column>

                                <el-table-column :label="$t('title.operate')" width="250" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button icon=" fa fa-line-chart" type="default" circle size="mini"
                                            :title="$t('title.viewMonitor')"
                                            @click="openDevice(true, scope.row)"></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- <el-pagination background :page-size="device_pagination.pageSize" :page-sizes="[10, 20, 50]"
                            :current-page.sync="device_pagination.current"
                            @current-change="handleDeviceListCurrentChange" @size-change="handleDeviceListSizeChange"
                            layout="prev, pager, next,sizes" :total="device_pagination.totalPage"
                            style="text-align: center; margin-top: 10px">
                        </el-pagination> -->
                        </div>
                    </div>
                </template>
            </el-form>
        </el-dialog>
        <el-dialog title="设备利用率加载率曲线" :visible.sync="deviceUseLoadRateDialog" width="80%" top="3%" height="300px">
            <el-form label-width="80px">
                <el-row :gutter="24">
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <h4>利用率趋势</h4>
                        <div class="infoLine" id="div_UseRateLine" style="height: 280px; margin-top: 5px"></div>
                    </el-col>
                </el-row>

                <el-row :gutter="24" style="margin-top:10px;">
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <h4>加载率趋势</h4>
                        <div class="infoLine" id="div_LoadRateLine" style="height: 280px; margin-top: 5px"></div>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

    </div>

</template>
<script>
import {
    authOperationCheck,
    exportExcelNew,
    getPotentialCustomerList,
    getExportCustomerList,
    getMonitorGathers,
    getDevicesByCustomer,
    getMonitorHistory,
    getCustById,
    getDeviceCustomerById,
    getDeviceData,
    getDsnListByCustomer,
    getDeviceUseLoadRateByDsnList
} from "../../api/api";
import { mapGetters, mapState } from "vuex";
import {
    setItemToLocalstorage,
    getItemFormLocalstorage,
} from "../../../utils/package-localstorage";

import monitorDeviceDialog from "../../components/content/maintabber/MonitorDeviceDialog";
//import monitorDialog from "../../components/content/monitor/MonitorDialog";
import monitorDeviceInfoDialog from "../../components/content/monitor/MonitorDeviceInfoDialog";
import monitorCcnTable from "../../components/content/monitor/MonitorCcnTable";
import monitorTripWarningDialog from "../../components/content/monitor/MonitorTripWarning";
import { monitorMixin } from "../../mixins/monitorMixin";
export default {
    name: "index",
    components: {
        "monitor-device-dialog": monitorDeviceDialog,
        //"monitor-dialog": monitorDialog,
        "monitor-deviceInfo-Dialog": monitorDeviceInfoDialog,
        "monitor-ccn-table": monitorCcnTable,
        "monitor-TripWarning-Dialog": monitorTripWarningDialog,
    },
    mixins: [monitorMixin],
    computed: {
        ...mapGetters({
            activeLang: "language",
        }),
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
    },
    watch: {
        optionscenterShow(val) {
            this.cascaderKey++;
        },
    },
    data() {
        return {
            projectType: "Back",
            isAdmin: false,
            cascaderKey: 1,
            tableKey: '',
            loading: false,
            companyTypeList: {
                直管: "desc.straightPipe",
                经销商: "desc.dealer",
                服务经销商: "desc.serviceDistributor",
                中间商: "desc.middleman",
                其他: "desc.other",
            },
            dialogTitle: "",
            dialogClient: false,
            dialogMonitor: false,
            deviceUseLoadRateDialog: false,
            dialogTripWarning: false,
            deviceListDialog: false,
            hisCustomer: {},

            hasExportAuth: false,
            tableData1: [],
            CustomerInputDto: {
                CustomerName: "",
                orderType: "",
                orderDirection: "",
            },
            clientform: {
                CustomerName: "",
                CustomerCode: "",
                CustomerCodeShow: "",
                CustomerCenter: "",
                RegionList: [],
                IndustryList: [],
                ProvinceList: [],
                ManageCpName: "",
                ManageCpCode: "",
                AgencyId: "",
                ProvinceName: "",
                CityName: "",
                Address: "",
                Industry: "",
                CompanyType: "",
                Longitude: "",
                Latitude: "",
            },
            gatherOptionShow: [],
            monitorDataList: [],
            deviceTableShow: [],
            customerId: "",

            optionscenter: [],
            optionscenterShow: [],
            pagination: {
                current: 1,
                pageSize: 10,
                totalPage: 0,
            },
            device_pagination: {
                current: 1,
                pageSize: 10,
                totalPage: 0,
            },
            form: {
                datalist: [],
            },
            props: { multiple: true },
            currentCustomer: null,
            deviceState: "",
            isCustomer: true,
            deviceTableData: [],
            UseLoadRateData: [],

            Linecolor: [
                "#28739A",
                "#51A470",
                "#FCBC5D",
                "#34A2BC",
                "#4A6AB5",
                "#6A6F89",
                "#CF554A",
                "#BECAD8",
                "#00A599",
                "#7AC3AB",
                "#689BA1",
                "#B9ECB0",
                "#9DA7E5",
                "#8DA7E5",
                "#7DA7E5",
                "#6DA7E5",
                "#5DA7E5",
                "#4DA7E5",
                "#3DA7E5",
                "#2DA7E5",
                "#9DA7E1",
                "#8DA7E2",
                "#7DA7E3",
                "#6DA7E4",
                "#5DA7E5",
                "#4DA7E6",
                "#3DA7E7",
                "#2DA7E8",
                "#8DA7E7",
                "#6DA7E8",
                "#51A890",
                "#BCBC9D",
                "#59A3BC",
                "#8A5AB5",
                "#9A3F89",
                "#CF214A",
                "#BECAD5",
                "#33A599",
                "#7AC4AB",
                "#549BA1",
                
                "#11A690",
                "#BABC3D",
                "#22A5BC",
                "#5A1AB3",
                "#1A2F99",
                "#CF333A",
                "#AECAD6",
                "#12A585",
                "#6AC2AB",
                "#254BA3",
                
                "#22A690",
                "#AACC3D",
                "#53AABC",
                "#1A1AB3",
                "#4A2F39",
                "#CF323A",
                "#AECAD2",
                "#32A595",
                "#2AC5AB",
                "#223BA6",
            ],
            dateLineList: [],

        };
    },
    created: function () {
        this.authOperation("Customer");
        // let name = getItemFormLocalstorage('userName');
        // let roles = getItemFormLocalstorage('roles')
        // if (name == 'admin' || roles.some(r => r == 'Admin')) {
        //     this.isAdmin = true;
        // }
    },
    async mounted() {
        this.getDataList();
    },
    methods: {
        authOperation(curPage) {
            var that = this;
            var res = authOperationCheck(curPage);
            that.hasCreateAuth = res.hasCreateAuth;
            that.hasUpdateAuth = res.hasUpdateAuth;
            that.hasDeleteAuth = res.hasDeleteAuth;
            that.hasImportAuth = res.hasImportAuth;
            that.hasExportAuth = res.hasExportAuth;
        },
        changeOrderType() {
            var curOrderType = this.CustomerInputDto.orderType;
            if (curOrderType) {
                if (this.CustomerInputDto.orderDirection == "")
                    this.CustomerInputDto.orderDirection = "0";

            }
            else {
                this.CustomerInputDto.orderDirection = "";
            }
        },
        getDataList(type = "normal") {
            let that = this;
            if (type == "search") {
                this.pagination.current = 1;
            }
            let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
            let postData = {
                CustomerName: this.CustomerInputDto.customerName,
                OrderType: this.CustomerInputDto.orderType,
                OrderDirection: this.CustomerInputDto.orderDirection,
                SkipCount: skipcount,
                MaxResultCount: this.pagination.pageSize,
            };
            getPotentialCustomerList(postData).then((res) => {
                let data = res.result.items;
                for (let index = 0; index < data.length; index++) {
                    data[index].companyType = this.$t(
                        this.companyTypeList[data[index].companyType]
                    );
                    data[index].customerType =
                        data[index].customerType == "Other"
                            ? "Rotary"
                            : data[index].customerType;
                }
                this.pagination.totalPage = res.result.totalCount;
                that.tableData1 = data;
            });
        },

        changeCState(value) {
            this.deviceState = value;
        },
        getDeviceTable(select, custId) {
            let that = this;
            let data = {
                idList: [custId],
                dsn: select.value1,
                state: select.value4,
                Language: this.activeLang,
            };
            getDevicesByCustomer(data).then((res) => {
                let data = res.result;
                that.deviceTable = data;
                //应该添加一个不循环的方法
                that.getDeviceData();
            });
        },

        //这是一个闭合循环 怎么在开始下一个循环时停止当前循环
        getDeviceData() {
            let that = this;

            if (!this.dialogClient) {
                return false;
            }

            let gsnList = new Array();
            for (let index = 0; index < that.deviceTable.length; index++) {
                gsnList.push(that.deviceTable[index].gsn);
            }
            let data = {
                gsnList: gsnList,
            };
            getDeviceData(data).then((res) => {
                let data = res.result;
                this.monitorHistoryData = data;
                this.deviceTableShow = new Array();
                for (let index = 0; index < that.deviceTable.length; index++) {
                    var curData = data.find(
                        (item) => item.gsn == that.deviceTable[index].gsn
                    );
                    let nameArrBS5DH = ["Package Discharge Pressure", "Running Time", "Loaded Time", "Airend Discharge Pressure", "Rated Pressure", "Airend Discharge Temperature", "Compression Ratio"];
                    let nameArrBM200 = ["Package Status", "Blower Inlet Pressure", "Blower Inlet Temperature", "Package Discharge Pressure", "Main Motor Winding Temperature", "Current Flow", "Main Vsd Motor Speed"];
                    let nameArrSVT = ["Inlet Pressure", "Airend Discharge Pressure", "Oil Injection Pressure", "Target Pressure", "Running Time", "Main Vsd Motor Current", "Main Vsd Motor Voltage"];
                    let nArr = new Array();
                    let indexName = this.isDingOrBian;
                    if (this.isDingOrBian == "BS5DH") {
                        nArr = nameArrBS5DH;
                    } else if (this.isDingOrBian == "BM200") {
                        nArr = nameArrBM200;
                    } else if (this.isDingOrBian == "SVT") {
                        nArr = nameArrSVT;
                    }
                    if (curData) {
                        let kstateValue = curData.data.find(a => a.n == "Compressor Status Word" || a.n.replace(" ", "") == "PackageStatus");
                        if (kstateValue && kstateValue.v2) {
                            that.deviceTable[index].kstate = that.activeLang == "zh" ? kstateValue.v2 : that.$t("desc." + kstateValue.v2.trim())
                        } else {
                            that.deviceTable[index].kstate = that.$t("tips.NA");
                        }
                        //pac八块 一级排气压力
                        let stage1PreValue = curData.data.find((a) => a.n.replace('  ', ' ') == "Stage 1 Pressure");
                        if (stage1PreValue && stage1PreValue.v) {
                            that.deviceTable[index].stage1Pre = stage1PreValue.v + " " + stage1PreValue.unit;
                        } else {
                            that.deviceTable[index].stage1Pre = that.$t("tips.NA");
                        }
                        //一级振动
                        let stage1VirValue = curData.data.find((a) => a.n.replace('  ', ' ') == "Stage 1 Virbation" || a.n.replace('  ', ' ') == "Stage 1 Vibration");
                        if (stage1VirValue && stage1VirValue.v) {
                            that.deviceTable[index].stage1Vir = stage1VirValue.v + " " + stage1VirValue.unit;
                        } else {
                            that.deviceTable[index].stage1Vir = that.$t("tips.NA");
                        }
                        //一级排气温度
                        let stage1TempValue = curData.data.find((a) => a.n.replace('  ', ' ') == "Stage 1 Temperature");
                        if (stage1TempValue && stage1TempValue.v) {
                            that.deviceTable[index].stage1Temp = stage1TempValue.v + " " + stage1TempValue.unit;
                        } else {
                            that.deviceTable[index].stage1Temp = that.$t("tips.NA");
                        }
                        //系统压力
                        let systemPreValue = curData.data.find((a) => a.n == "System Pressure");
                        if (systemPreValue && systemPreValue.v) {
                            that.deviceTable[index].systemPre = systemPreValue.v + " " + systemPreValue.unit;
                        } else {
                            that.deviceTable[index].systemPre = that.$t("tips.NA");
                        }
                        //排气压力
                        let dischargePreValue = curData.data.find((a) => a.n == "Discharge Pressure");
                        if (dischargePreValue && dischargePreValue.v) {
                            that.deviceTable[index].dischargePre = dischargePreValue.v + " " + dischargePreValue.unit;
                        } else {
                            that.deviceTable[index].dischargePre = that.$t("tips.NA");
                        }
                        //二级进气温度
                        let stage2IntempValue = curData.data.find((a) => a.n == "Stage 2 Inlet Temp");
                        if (stage2IntempValue && stage2IntempValue.v) {
                            that.deviceTable[index].stage2Intemp = stage2IntempValue.v + " " + stage2IntempValue.unit;
                        } else {
                            that.deviceTable[index].stage2Intemp = that.$t("tips.NA");
                        }

                        let targetPValue = curData.data.find((a) => a.n == "Target Pressure");
                        if (targetPValue && targetPValue.v) {
                            that.deviceTable[index].targetP = targetPValue.v + " " + targetPValue.unit;
                        } else {
                            that.deviceTable[index].targetP = that.$t("tips.NA");
                        }

                        let vmsValue = curData.data.find((a) => a.n == "Vsd Motor Speed");
                        if (vmsValue && vmsValue.v) {
                            that.deviceTable[index].vms = vmsValue.v + " " + vmsValue.unit;
                        } else {
                            that.deviceTable[index].vms = that.$t("tips.NA");
                        }

                        let ktimeValue = curData.data.find((a) => a.z == "运行时间");
                        if (ktimeValue && ktimeValue.v) {
                            if (that.IsShowSensitive == true) {
                                that.deviceTable[index].kTime = ktimeValue.v;
                            } else {
                                that.deviceTable[index].kTime = ktimeValue.v + that.$t("desc.simpleHours");
                            }
                        } else {
                            that.deviceTable[index].kTime = that.$t("tips.NA");
                        }

                        let dpvalue = curData.data.find(
                            (a) => a.n == "Compressor Discharge Pressure"
                        );
                        if (dpvalue && dpvalue.v) {
                            that.deviceTable[index].dp = dpvalue.v + " " + dpvalue.unit;
                        } else {
                            that.deviceTable[index].dp = that.$t("tips.NA");
                        }

                        var fsdtValue = curData.data.find(
                            (a) => a.n == "Final Stage Discharge Temperature"
                        );
                        var twosdtValue = curData.data.find(
                            (a) => a.n == "2nd Stage Discharge Temperature"
                        );
                        if (fsdtValue && fsdtValue.v > "0.0") {
                            that.deviceTable[index].sdt2 = fsdtValue.v
                                ? fsdtValue.v + " " + fsdtValue.unit
                                : that.$t("tips.NA");
                        } else if (twosdtValue) {
                            that.deviceTable[index].sdt2 = twosdtValue.v
                                ? twosdtValue.v + " " + twosdtValue.unit
                                : that.$t("tips.NA");
                        } else if (fsdtValue && fsdtValue.v == "0.0") {
                            that.deviceTable[index].sdt2 = fsdtValue.v
                                ? fsdtValue.v + " " + fsdtValue.unit
                                : that.$t("tips.NA");
                        } else {
                            that.deviceTable[index].sdt2 = that.$t("tips.NA");
                        }

                        var rpValue = curData.data.find((a) => a.n == "Rated Pressure");
                        if (rpValue && rpValue.v) {
                            that.deviceTable[index].rp = rpValue.v + " " + rpValue.unit;
                        } else {
                            that.deviceTable[index].rp = that.$t("tips.NA");
                        }

                        var mcValue = curData.data.find((a) => a.n == "Driver Motor Current");
                        let mmcpA = curData.data.find(
                            (a) => a.n == "Main Motor Current Phase A"
                        );
                        if (mcValue && mcValue.v > "0.0") {
                            that.deviceTable[index].mc = mcValue.v
                                ? mcValue.v + " " + mcValue.unit
                                : that.$t("tips.NA");
                        } else if (mmcpA) {
                            that.deviceTable[index].mc = mmcpA.v ? mmcpA.v + " " + mmcpA.unit : that.$t("tips.NA");
                        } else if (mcValue && mcValue.v == "0.0") {
                            that.deviceTable[index].mc = mcValue.v
                                ? mcValue.v + " " + mcValue.unit
                                : that.$t("tips.NA");
                        } else {
                            that.deviceTable[index].mc = that.$t("tips.NA");
                        }

                        var loadTimeValue = curData.data.find((a) => a.z == "加载时间" || a.z == "全加载");
                        if (loadTimeValue && loadTimeValue.v) {
                            if (that.IsShowSensitive == true) {
                                that.deviceTable[index].loadTime = loadTimeValue.v;
                            } else {
                                that.deviceTable[index].loadTime = loadTimeValue.v + that.$t("desc.simpleHours");
                            }
                        } else {
                            that.deviceTable[index].loadTime = that.$t("tips.NA");
                        }
                        //#region BV八块数据
                        that.eightSpanArr[indexName] = new Array();
                        for (let index = 0; index < nArr.length; index++) {
                            const element = nArr[index];
                            let BS5DHValue = curData.data.find((a) => a.n == element);
                            if (BS5DHValue && BS5DHValue.v) {
                                if (element == "Running Time" && that.IsShowSensitive == true) {
                                    that.deviceTable[index][indexName + index] = BS5DHValue.v
                                } else if (element == "Running Time" && that.IsShowSensitive == false) {
                                    that.deviceTable[index][indexName + index] = BS5DHValue.v + that.$t("desc.simpleHours");
                                } else {
                                    that.deviceTable[index][indexName + index] = BS5DHValue.v + " " + (BS5DHValue.unit ? BS5DHValue.unit : "");
                                }
                            } else {
                                that.deviceTable[index][indexName + index] = that.$t("tips.NA");
                            }
                            that.eightSpanArr[indexName].push(indexName + index);
                            let translate = that.$t("eightSpan." + indexName + index);
                        }
                        //#endregion

                    } else {
                        that.deviceTable[index].kstate = that.$t("tips.NA");
                        that.deviceTable[index].kstateNum = that.$t("tips.NA");
                        that.deviceTable[index].targetP = that.$t("tips.NA");
                        that.deviceTable[index].vms = that.$t("tips.NA");
                        that.deviceTable[index].kTime = that.$t("tips.NA");
                        that.deviceTable[index].dp = that.$t("tips.NA");
                        that.deviceTable[index].dt = that.$t("tips.NA");
                        that.deviceTable[index].fsdt = that.$t("tips.NA");
                        that.deviceTable[index].sdt2 = that.$t("tips.NA");
                        that.deviceTable[index].rp = that.$t("tips.NA");
                        that.deviceTable[index].mc = that.$t("tips.NA");
                        that.deviceTable[index].loadTime = that.$t("tips.NA");

                        that.deviceTable[index].stage1Pre = that.$t("tips.NA");
                        that.deviceTable[index].stage1Vir = that.$t("tips.NA");
                        that.deviceTable[index].stage1Temp = that.$t("tips.NA");
                        that.deviceTable[index].systemPre = that.$t("tips.NA");
                        that.deviceTable[index].dischargePre = that.$t("tips.NA");
                        that.deviceTable[index].stage2Intemp = that.$t("tips.NA");

                        //BV八块数据
                        for (let index = 0; index < nArr.length; index++) {
                            const element = nArr[index];
                            that.deviceTable[index][indexName + index] = that.$t("tips.NA");
                        }
                        // if (that.DeviceInfo.unLoadTime) that.DeviceInfo.unLoadTime = "";
                    }
                    if (that.deviceState) {
                        if (
                            that.deviceTable[index].kstate &&
                            that.deviceTable[index].kstate.indexOf(that.deviceState) != -1
                        ) {
                            that.deviceTableShow.push(that.deviceTable[index]);
                        } else {
                        }
                    } else {
                        that.deviceTableShow.push(that.deviceTable[index]);
                    }
                }
                //如果打开了ccn列表就试试更新数据
                // if (this.dialogDeviceCCN) {
                //   this.getCcnTable(this.ccnGsn);
                // }
                if (that.dialogDevice) {
                    that.DeviceInfo = JSON.parse(
                        JSON.stringify(
                            that.deviceTableShow.find((a) => a.dsn == that.infoDsn)
                        )
                    );
                    that.DeviceInfoShow = JSON.parse(JSON.stringify(that.DeviceInfo));
                }
                this.stopDeviceData = setTimeout(function () {
                    that.getDeviceData();
                }, 70 * 1000);
            });
        },
        getMonitorHistory(value, value2, value3, value4, type, deviceOption) {
            let that = this;
            let data = {
                gsnList: value2,
                paraList: value.value2,
                startTime: value3,
                endTime: value4,
                dateTime: value.date,
                type: type,
                language: this.activeLang,
            };
            getMonitorHistory(data).then((res) => {
                let data = res.result;
                if (data.length === 0) {
                    that.$message({
                        showClose: true,
                        message: "未找到监控数据",
                        type: "error",
                    });
                    return false;
                }
                //先赋值dsn 再渲染图标
                that.monitorDataList = new Array();
                for (let index = 0; index < data.length; index++) {
                    //.赋值无法监控
                    data[index].dsn = deviceOption.find(
                        (a) => a.gsn == data[index].gsn
                    )?.dsn;

                    //push赋值对象才能监控到变化
                    that.monitorDataList.push(data[index]);
                }
                this.$nextTick(() => {
                    setTimeout(() => {
                        for (let index = 0; index < data.length; index++) {
                            //.赋值无法监控
                            data[index].dsn = deviceOption.find(
                                (a) => a.gsn == data[index].gsn
                            )?.dsn;
                            //push赋值对象才能监控到变化
                            that.initEcharts("Kchart_" + index, that.monitorDataList[index]);
                        }
                    }, 300);
                });
            });
        },
        getGatherOption() {
            let that = this;
            getMonitorGathers().then((res) => {
                let data = res.result;
                that.gatherOption = data;
                that.gatherOptionShow = this.unique(data.filter((bbb) =>
                    this.unitList.some((unit) => unit == bbb.unit)
                ));
            });
        },

        unique(arr) {//去重
            const res = new Map();
            return arr.filter((a) => !res.has(a.name) && res.set(a.name, 1));
        },
        async openClient(visible, item) {
            this.dialogClient = visible;
            if (visible) {
                this.dialogTitle = item.customerName;
                this.getDeviceTable("", item.customerId);
                let res = await getDeviceCustomerById({ id: item.customerId });
                this.CustomerInfo = res.result;
                this.customerId = item.id;
            } else {
                this.CustomerInfo = {};
                this.customerId = "";
                this.deviceTableShow = [];
                if (this.stopDeviceData) {
                    clearTimeout(this.stopDeviceData);
                }
            }
        },

        async openMonitor(visible, item) {
            this.dialogMonitor = visible;
            if (visible) {
                let res = await getCustById({ id: item.customerId })
                var curCustomer = res.result;
                this.hisCustomer = curCustomer;
                this.dialogTitle = item.customerName;
                // this.$nextTick(() => {
                //   this.$refs.monitorRef.showEcharts();
                // });
                // this.$refs.monitorRef.showEcharts();
            } else {
                this.monitorDataList = [];
            }
        },
        async openUseLoadRatePopup(visible, item) {
            this.deviceUseLoadRateDialog = visible;

            if (visible) {
                this.dialogTitle = item.customerName;
                let that = this;
                getDsnListByCustomer(item.customerId).then((res) => {
                    let data = res.result;
                    var para = {
                        dsnList: data
                    }
                    that.getDeviceUseLoadRateByDsnList(para);
                });
            } else {
                // this.CustomerInfo = {};
                // this.customerId = "";
                // this.deviceTableShow = [];
                // if (this.stopDeviceData) {
                //     clearTimeout(this.stopDeviceData);
                // }
            }
        },
        initEcharts(id, echartData) {
            var Kchart1 = this.$echarts.init(document.getElementById(id));

            var Linecolor = ["#4D9DC6", "#95DBD3", "#A5E893", "#FFE8AA", "#4179A2"];
            var Linecolor2 = [
                "rgba(0,117,155,0.05)",
                "rgba(0,182,125,0.05)",
                "rgba(3,81,139,0.05)",
                "rgba(255,222,118,0.05)",
                "rgba(54,144,137,0.05)",
            ];
            var seriesList = [];
            let codeListShow = new Array();
            for (let index = 0; index < echartData.codeList.length; index++) {
                let curCode = "";
                if (this.activeLang == "zh") {
                    curCode = this.gatherOption.find(
                        (item) => item.name == echartData.codeList[index]
                    )?.nameZH;
                } else {
                    curCode = this.gatherOption.find(
                        (item) => item.name == echartData.codeList[index]
                    )?.name;
                }
                codeListShow.push(curCode);
            }

            for (var i = 0; i < echartData.chartDataList.length; i++) {
                var temp = {
                    name: echartData.codeList[i],
                    type: "line",
                    smooth: true, //是否平滑
                    showSymbol: false,
                    symbolSize: 4,
                    lineStyle: {
                        normal: {
                            color: Linecolor[i],
                            width: 2,
                        },
                    },
                    itemStyle: {
                        borderColor: Linecolor[i],
                        color: Linecolor[i],
                    },
                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: Linecolor[i] },
                                { offset: 1, color: Linecolor2[i] },
                            ]),
                        },
                    },
                    data: echartData.chartDataList.find(
                        (item) => item.code === echartData.codeList[i]
                    )?.dataList,
                };
                seriesList.push(temp);
            }

            var optionK = {
                legend: {
                    data: codeListShow,
                    textStyle: {
                        color: "#999",
                        align: "left",
                    },
                    left: 10,
                    top: 10,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                    position: function (point, params, dom, rect, size) {
                        // 固定在顶部
                        return [point[0] / 2 - 20, point[1] - 150];
                    },
                    backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
                    borderColor: "rgba(0,0,0,0)",
                    textStyle: {
                        color: "#828393",
                        fontSize: 10,
                        fontFamily: "Arial",
                    },
                    formatter: (param) => {
                        let str = "<div style='margin: 0px 0 0;line-height:1;'>" +
                            "<div style='margin: 0px 0 0;line-height:1;'>" +
                            "<div style='font-size:10px;color:#828393;font-weight:400;line-height:1;'>" + param[0].axisValue + "</div>" +
                            "<div style='margin: 0px 0 0;line-height:1;'>";
                        for (let index = 0; index < param.length; index++) {
                            let curCode = "";
                            if (this.activeLang == "zh") {
                                curCode = this.gatherOption.find(
                                    (item) => item.name == echartData.codeList[index]
                                )?.nameZH;
                            } else {
                                curCode = this.gatherOption.find(
                                    (item) => item.name == echartData.codeList[index]
                                )?.name;
                            }
                            const element = param[index];
                            const unit = echartData.chartDataList.find(
                                (item) => item.code === element.seriesName
                            )?.unit ?? "";
                            str += "<div style='margin: 10px 0 0;line-height:1;'>" +
                                "<div style='margin: 0px 0 0;line-height:1;'>" +
                                element.marker +
                                "<span style = 'font-size:10px;color:#828393;font-weight:400;margin-left:2px'>" + curCode + "</span>" +
                                "<span style='float:right;margin-left:20px;font-size:10px;color:#828393;font-weight:900'>" + (element.value + "").parseNum() + "&nbsp" + unit + "<span>" +
                                "<div style='clear:both'></div></div> <div style='clear:both'></div></div>"
                        }
                        str += "<div style='clear:both'></div></div> <div style='clear:both'></div></div> <div style='clear:both'></div></div>"
                        return str;
                    }
                },
                grid: {
                    top: 60,
                    left: 40,
                    right: 40,
                    bottom: 80,
                },
                dataZoom: [
                    {
                        show: true,
                        height: 26,
                        xAxisIndex: [0],
                        bottom: 20,
                        start: 80,
                        end: 100,
                        textStyle: {
                            color: "#A7B7CC",
                        },
                    },
                    {
                        type: "inside",
                        show: true,
                        height: 15,
                        start: 1,
                        end: 35,
                    },
                ],
                xAxis: [
                    {
                        type: "category",
                        splitLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: true,
                            color: "#828393",
                            textStyle: {
                                fontSize: 10,
                                fontFamily: "Arial",
                            },
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },

                        boundaryGap: false,
                        data: echartData.dateTimeList,
                    },
                ],

                yAxis: {
                    type: "value",
                    splitNumber: 3,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#3A3D46",
                        },
                    },
                    axisLabel: {
                        show: true,
                        color: "#828393",
                        textStyle: {
                            fontSize: 10,
                            fontFamily: "Arial",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                },
                series: seriesList,
            };

            Kchart1.clear();
            setTimeout(() => {
                try {
                    Kchart1.setOption(optionK);
                } catch (error) {
                    console.log('Error setting option:', error);
                }
            }, 500);


            window.addEventListener("resize", () => {
                Kchart1.resize();
            });
        },
        async getDeviceUseLoadRateByDsnList(dsnList) {
            let that = this;
            let res = await getDeviceUseLoadRateByDsnList(dsnList);
            that.UseLoadRateData = res.result;

            let dateList = that.UseLoadRateData[0].dayTimeList;
            this.dateLineList = dateList;
            // that.InitMutiUseRateLine(that.UseLoadRateData, "useRate","div_UseRateLine");
            // that.InitMutiUseRateLine(that.UseLoadRateData, "loadRate","div_LoadRateLine");

            that.initLineDom(that.UseLoadRateData, "useRate", "div_UseRateLine");
            that.initLineDom(that.UseLoadRateData, "loadRate", "div_LoadRateLine");
        },

        initLineDom(data, type, dom) {
            var Kchart = this.$echarts.init(document.getElementById(dom));
            Kchart.setOption(this.initLine(type, data), true);
            window.addEventListener("resize", () => {
                Kchart.resize();
            });
        },

        initLine(type, Data) {
            Data = Data.filter((a) => a.type == type);
            let that = this;
            var mWidth = 0;
            if (this.isCollapse) {
                mWidth = document.documentElement.clientWidth - 226;
            } else {
                mWidth = document.documentElement.clientWidth - 97;
            }
            mWidth = mWidth * 0.3 - 30;

            var colorL = this.Linecolor;
            var timeList = this.dateLineList;

            var series = [];
            var selected = [];
            var legendData=[];

            for (let i = 0; i < Data.length; i++) {
                legendData.push(Data[i].dsn);
                var seriesTemp = {
                    name: Data[i].dsn,
                    type: "line",
                    smooth: false, //是否平滑
                    showSymbol: true,
                    symbolSize: 6,
                    // label: {
                    //     show: true,
                    //     textStyle: {
                    //         color: "#fff",
                    //         fontSize: 10,
                    //     },
                    //     formatter: "{c} %",
                    // },
                    lineStyle: {
                        normal: {
                            color: colorL[i%60],
                        },
                    },
                    itemStyle: {
                        color: colorL[i%60],
                        borderColor: colorL[i%60],
                        borderWidth: 2,
                    },
                    emphasis: {
                        focus: "series",
                    },
                    data: Data[i].dayDataList,
                };
                series.push(seriesTemp);
            }

            var temp = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "line", // 默认为直线，可选为：'line' | 'shadow'
                    },
                    position: "top",
                    backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
                    borderColor: "rgba(0,0,0,0)",
                    textStyle: {
                        color: "#828393",
                        fontSize: 12,
                        fontFamily: "Arial",
                    },
                    formatter: function (params) {
                        var temp = params[0].name;
                        for (let i = 0; i < params.length; i++) {
                            temp =
                                temp +
                                "<br />" +
                                params[i].marker +
                                params[i].seriesName +
                                ": <span style='color:#fff;font-size:10px;font-family:Arial'>" +
                                params[i].value +
                                "%</span>";
                        }
                        return temp;
                    },
                },
                legend: {
                    icon: "circle",
                    orient: "vertical",
                    right: 10,
                    left: "85%",
                    top: 5,
                    bottom: 20,
                    type : 'scroll',
                    //scrollable:true,
                    //width:'20%',
                    //height:'20%',
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 20,
                    textStyle: {
                        color: "#beceff", //元字颜色
                    },
                    data: legendData,
                    // formatter: (name) => {
                    //     return (
                    //         // {name|' + item.name + '}
                    //         "{name|" + this.$echarts.format.truncateText(name, mWidth, "…") + "} "
                    //     );
                    // },
                    textStyle: {
                        color: "#beceff", //元字颜色
                        fontSize: 14,
                        rich: {
                            name: {
                                color: "#fff",
                                fontSize: 12,
                                fontFamily: "Arial, 'microsoft yahei'",
                                width: mWidth,
                                align: "left",
                            },
                        },
                    },
                },
                grid: {
                    top: 10,
                    left: 40,
                    right: "20%",
                    bottom: 0,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: timeList,
                    interval: 0,
                    axisLabel: {
                        textStyle: {
                            margin: 5,
                            color: "#828393",
                            fontSize: 10,
                            fontFamily: "Arial",
                            lineHeight: 12,
                        },
                        interval: 0,
                        formatter: function (params) {
                            var newParamsName = ""; // 最终拼接成的字符串
                            var paramsNameNumber = params.length; // 实际标签的个数
                            var provideNumber = 8; // 每行能显示的字的个数
                            var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                            /**
                             * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                             */
                            // 条件等同于rowNumber>1
                            if (paramsNameNumber > provideNumber) {
                                /** 循环每一行,p表示行 */
                                for (var p = 0; p < rowNumber; p++) {
                                    var tempStr = ""; // 表示每一次截取的字符串
                                    var start = p * provideNumber; // 开始截取的位置
                                    var end = start + provideNumber; // 结束截取的位置
                                    // 此处特殊处理最后一行的索引值
                                    if (p == rowNumber - 1) {
                                        // 最后一次不换行
                                        tempStr = params.substring(start, paramsNameNumber);
                                    } else {
                                        // 每一次拼接字符串并换行
                                        tempStr = params.substring(start, end) + "\n";
                                    }
                                    newParamsName += tempStr; // 最终拼成的字符串
                                }
                            } else {
                                // 将旧标签的值赋给新标签
                                newParamsName = params;
                            }
                            //将最终的字符串返回
                            return newParamsName;
                        },
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#3A3D46",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    boundaryGap: false,
                },
                yAxis: [
                    {
                        type: "value",
                        // splitNumber: 8,
                        axisLabel: {
                            textStyle: {
                                color: "#828393",
                                fontSize: 10,
                                fontFamily: "Arial",
                            },
                            formatter: "{value} %",
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#3A3D46",
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#3A3D46",
                            },
                        },
                        // min: 35,
                        min: function (value) {
                            var temp = (value.min - 1).toFixed(0);
                            return temp > 0 ? temp : 0;
                        },
                        // max: 60,
                    },
                ],
                series: series,
            };
            return temp;
        },
        InitMutiUseRateLine(data, type, dom) {
            var that = this;
            //data = data.find(x => x.type == type);            
            data = data.filter((a) => a.type == type);
            const curDomId = document.getElementById(dom);
            // if (type == "loadRate")
            //     curDomId = document.getElementById("div_LoadRateLine");
            var URateLine = this.$echarts.init(curDomId);
            var dataLine = data.dayDataList;
            var timeLine = data.dayTimeList;
            var optionURateLine = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                    position: function (point, params, dom, rect, size) {
                        // 固定在顶部
                        return [point[0] / 2 - 80, point[1] - 80];
                    },
                    backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
                    borderColor: "rgba(0,0,0,0)",
                    textStyle: {
                        color: "#828393",
                        fontSize: 10,
                        fontFamily: "Arial",
                    },
                    formatter: "{b}<br />{a}<br />{c}% ",
                },
                grid: {
                    top: 5,
                    left: 30,
                    right: 5,
                    bottom: 20,
                },
                xAxis: {
                    type: "category",
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: true,
                        color: "#828393",
                        textStyle: {
                            fontSize: 10,
                            fontFamily: "Arial",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },

                    boundaryGap: false,
                    data: timeLine,
                },
                yAxis: {
                    type: "value",
                    splitNumber: 3,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#3A3D46",
                        },
                    },
                    axisLabel: {
                        show: true,
                        color: "#828393",
                        textStyle: {
                            fontSize: 10,
                            fontFamily: "Arial",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                },
                series: {
                    name: that.$t("desc.UtilizationRate"),
                    type: "line",
                    smooth: true, //是否平滑
                    showAllSymbol: false,
                    symbol: "circle",
                    symbolSize: 5,
                    lineStyle: {
                        normal: {
                            color: "rgba(255,255,255,1)",
                        },
                    },
                    itemStyle: {
                        // color: "rgba(58,64,73,1)",
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 1,
                    },
                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: "rgba(255,255,255,0.5)" },
                                { offset: 0.9, color: "rgba(255,255,255,0)" },
                                { offset: 1, color: "rgba(255,255,255,0)" },
                            ]),
                        },
                    },
                    data: dataLine,
                    cursor: "default",
                },
            };
            URateLine.setOption(optionURateLine);

            window.addEventListener("resize", () => {
                URateLine.resize();
            });
        },

        openTripWarningDialog(visible) {
            this.dialogTripWarning = visible;
        },
        openNotice(title, message, type) {
            this.$notify({
                title: title,
                message: message,
                type: type,
            });
        },
        togleCollapse() {
            this.isCollapse = !this.isCollapse;
        },

        handleAccredit(index, row) { },
        handleDelete(index, row) { },
        onSubmit() { },

        resetKeyword() {
            this.CustomerInputDto = {};
        },
        handleCurrentChange(val) {
            this.pagination.current = val;
            this.getDataList();
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.getDataList();
        },
        exportCustomerList() {
            this.loading = true;
            let that = this;
            // var data = {
            //   Ccn: ccn,
            //   Version: version,
            // };
            // var headers = [
            //   { key: "customerName", title: "客户名称" },
            //   { key: "customerCode", title: "客户编码" },
            //   { key: "customerCenter", title: "客户中心" },
            //   { key: "manageCpName", title: "管理单位名称" },
            //   { key: "manageCpCode", title: "管理单位代码" },
            //   { key: "companyType", title: "单位性质" },
            //   { key: "provinceName", title: "省" },
            //   { key: "cityName", title: "市" },
            //   { key: "address", title: "地址" },
            //   { key: "industry", title: "行业" },
            //   { key: "longitude", title: "经度" },
            //   { key: "latitude", title: "纬度" },
            // ];
            var exportData = [
                [
                    this.$t('desc.customerName'),
                    this.$t('title.customerCode'),
                    this.$t('title.brand'),
                    this.$t('title.customerCenter'),
                    this.$t('title.customerTypePac'),
                    this.$t('title.managementUnit'),
                    this.$t('title.managementCode'),
                    this.$t('title.companyType'),
                    this.$t('title.province'),
                    this.$t('title.city'),
                    this.$t('title.address'),
                    this.$t('title.industry'),
                    this.$t('title.longitude'),
                    this.$t('title.latitude'),
                ],
            ];
            var fileName = this.$t("exportContent.客户列表导出") + ".xlsx";
            let postData = {
                CustomerName: this.CustomerInputDto.customerName,
                IndustryList: this.CustomerInputDto.industryList,
                CityList: this.CustomerInputDto.cityList,
                CenterList: this.CustomerInputDto.centerList,
                ProductLine: this.CustomerInputDto.productLine,
                Language: this.activeLang,
            };
            getExportCustomerList(postData).then((res) => {
                if (res.result) {
                    var data = res.result;
                    //导入数据里有null会导致文件损坏
                    const dataSource = data.map((item) => {
                        Object.keys(item).forEach((key) => {
                            // 后端传null node写入会有问题
                            if (item[key] === null) {
                                item[key] = "";
                            }

                            if (Array.isArray(item[key])) {
                                item[key] = item[key].join(",");
                            }
                        });
                        return item;
                    });
                    dataSource.forEach((item) => {
                        let rowData = [];
                        rowData = [
                            item.customerName,
                            item.customerCode,
                            item.brandCode,
                            item.customerCenter,
                            item.customerType == "Other" ? "Rotary" : item.customerType,
                            item.manageCpName,
                            item.manageCpCode,
                            this.$t("desc." + item.companyType),
                            item.provinceName,
                            item.cityName,
                            item.address,
                            item.industry,
                            item.longitude,
                            item.latitude,
                        ];
                        exportData.push(rowData);
                    });
                    exportExcelNew(exportData, fileName);
                    // exportExcel(headers, dataSource, fileName);
                    this.loading = false;
                }
            });
        },
        find(array, model) {
            var index = array.findIndex(
                (item) =>
                    item.CustomerCode === model.CustomerCode &&
                    item.CompanyType === model.CompanyType &&
                    item.ManageCpCode === model.ManageCpCode
            );
            return index; // -1 说明array中不存在id为str的对象
        },
    },
};
</script>

<style scoped>
#formPer .el-form-item__content {
    line-height: 35px;
    border-left: 1px solid #ebeef5;
    padding-left: 10px;
}

#formPer>.el-form-item {
    margin-bottom: 0px;
    border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
    border: 0;
}

#formPer .noborder {
    border: 0;
    margin-top: 20px;
}
</style>